export const theme = {
  input: 'autosuggest_inputbox',
  container: 'autosuggest_container',
  suggestionsContainer: 'autosuggest_suggestions_container',
  suggestionsList: 'autosuggest_suggestions_list',
  suggestion: 'autosuggest_suggestion__item',
  suggestionHighlighted: 'autosuggest_suggestion__item--highlighted',
};
